var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.965,
    height: 11.633,
    viewBox: "0 0 12.965 11.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2669",
    "data-name": "Group 2669",
    transform: "translate(989.334 6641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10889",
    "data-name": "Path 10889",
    d: "M204.015,152.2a1.98,1.98,0,0,0-1.335-1.113v-4.995a.485.485,0,0,0-.969,0v4.993a2.243,2.243,0,0,0-.339.116,2,2,0,0,0,.339,3.757v1.8a.485.485,0,0,0,.969,0v-1.8a1.993,1.993,0,0,0,1.335-2.76Zm-.856,1.188h0a1.03,1.03,0,1,1-1.389-1.3,1,1,0,0,1,.422-.092,1.032,1.032,0,0,1,.94.606,1.02,1.02,0,0,1,.031.788Z",
    transform: "translate(-1189.531 -6786.604)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10890",
    "data-name": "Path 10890",
    d: "M411.212,152.2a1.981,1.981,0,0,0-1.336-1.113v-4.995a.485.485,0,0,0-.969,0v4.993a2.25,2.25,0,0,0-.339.116,2,2,0,0,0,.339,3.757v1.8a.485.485,0,1,0,.969,0v-1.8a1.993,1.993,0,0,0,1.336-2.76Zm-.856,1.188h0a1.03,1.03,0,1,1-1.389-1.3,1.012,1.012,0,0,1,.422-.092,1.032,1.032,0,0,1,.94.606,1.019,1.019,0,0,1,.027.788Z",
    transform: "translate(-1387.761 -6786.604)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10891",
    "data-name": "Path 10891",
    d: "M306.513,148.024a2.262,2.262,0,0,0-.221-.068v-1.871a.485.485,0,0,0-.97,0v1.878a2,2,0,0,0-.22,3.81c.073.027.148.049.221.068v4.908a.485.485,0,0,0,.97,0v-4.91a1.854,1.854,0,0,0,.339-.116,2,2,0,0,0-.119-3.7Zm.267,2.242a1.03,1.03,0,1,1-.965-1.394,1.05,1.05,0,0,1,.363.065,1.051,1.051,0,0,1,.6,1.328Z",
    transform: "translate(-1288.661 -6786.601)",
    fill: "#ccc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDateIcon);
export default __webpack_public_path__ + "static/media/filterDateIcon.b8233f2b456081f2ad6b47c427256b1c.svg";
export { ForwardRef as ReactComponent };